import { render } from "./ProfileEditFormPanelNewTheme.vue?vue&type=template&id=563ecf2d&scoped=true"
import script from "./ProfileEditFormPanelNewTheme.vue?vue&type=script&lang=js"
export * from "./ProfileEditFormPanelNewTheme.vue?vue&type=script&lang=js"

import "./ProfileEditFormPanelNewTheme.vue?vue&type=style&index=0&id=563ecf2d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-563ecf2d"]])

export default __exports__